import Link from '@corratech/pylot-ui/src/Link'
import s from '@corratech/air-ooka-header/Menu/DesktopMenu/DesktopMenu.module.scss'
import React from 'react'
import { useTopNavTracking } from '@corratech/pylot-tag-manager/src/hooks/useMenuTracking'

export const OOKA_FOR_BUSINESS = 'ooka for business'

export const OtherMenuItem = () => {
    const trackMenuClick = useTopNavTracking()
    return (
        <Link
            className={s['MainMenuLink']}
            href="/ooka-for-business"
            onClick={() =>
                trackMenuClick(OOKA_FOR_BUSINESS, '/ooka-for-business', [
                    'ooka-for-business'
                ])
            }
        >
            <span>{OOKA_FOR_BUSINESS}</span>
        </Link>
    )
}
